import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do you handle permits and inspections for legal basements?",
    a: "Yes — we manage the full process: architectural drawings, building permits, electrical & plumbing rough-in inspections, fire-separation requirements, and final occupancy sign-off. You get a fully legal, rentable second unit.",
  },
  {
    q: "How long does a typical renovation take?",
    a: "Most kitchens and bathrooms take 3–6 weeks. Legal basements run 8–12 weeks depending on permit turnaround. Custom homes vary by scope. We provide a firm timeline with milestones in your quote.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. We carry $2M liability insurance, are WSIB covered, and work with licensed electricians and plumbers on every project. Documentation can be provided before work begins.",
  },
  {
    q: "What does the free quote include?",
    a: "An on-site (or video) walkthrough, scope of work, itemized material & labor estimate, suggested timeline, and answers to your questions — no obligation and no pressure.",
  },
  {
    q: "Which areas of the GTA do you serve?",
    a: "Toronto, Mississauga, Brampton, Markham, Vaughan, Oakville, Richmond Hill, Etobicoke, Scarborough, North York and surrounding communities.",
  },
  {
    q: "How does the 24/7 emergency service work?",
    a: "Call +1 647 446 6869 any time — day, night, weekends or holidays. We dispatch a licensed tech for burst pipes, electrical faults, flooded basements and other urgent property issues, typically within 60 minutes inside the GTA.",
  },
  {
    q: "What kind of payment schedule do you offer?",
    a: "We use a milestone-based payment schedule (deposit, framing/rough-in, mid-project, final). No large upfront payments — you pay as work is completed and approved.",
  },
  {
    q: "Do you offer a warranty on your work?",
    a: "Yes. All workmanship is backed by a 2-year warranty, and we honor manufacturer warranties on installed materials and fixtures.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-36 bg-[#EDE6D8]/40" data-testid="faq-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#B08D5B]" />
              <span className="label-overline text-[10px] text-[#B08D5B]">FAQ</span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl tracking-tight font-light text-[#0B1B33] leading-[1.05]">
              Quick answers to <span className="italic text-[#B08D5B]">common</span>{" "}
              questions.
            </h2>
            <p className="mt-7 font-body text-stone-600 leading-[1.85] text-[15px]">
              Don't see your question? Call{" "}
              <a
                href="tel:+14168264590"
                className="text-[#B08D5B] font-semibold underline underline-offset-4 decoration-[#B08D5B]/40"
                data-testid="faq-call-link"
              >
                +1 416 826 4590
              </a>{" "}
              or send a message — we usually respond same day.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="border-t border-[#0B1B33]/10"
              data-testid="faq-accordion"
            >
              {FAQS.map((item, idx) => (
                <AccordionItem
                  key={idx}
                  value={`item-${idx}`}
                  className="border-b border-[#0B1B33]/10"
                  data-testid={`faq-item-${idx}`}
                >
                  <AccordionTrigger className="text-left font-heading font-medium text-[#0B1B33] hover:no-underline hover:text-[#B08D5B] py-6 text-lg sm:text-xl group">
                    <span className="flex items-start gap-5">
                      <span className="font-heading text-xs text-[#B08D5B] mt-2 font-medium tracking-wider">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      <span>{item.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-stone-600 font-body leading-[1.85] pb-6 pl-12 text-[15px]">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
